import React from 'react';
import { BrowserRouter as Router, useRoutes } from 'react-router-dom';
import { QueryClient, QueryClientProvider, QueryCache } from '@tanstack/react-query';
import Notification from './components/Notification';
import PostModal from './components/PostModal/PostModal';
import ErrorModal from './components/ErrorModal';
import { routes } from './routes';

const queryClient = new QueryClient({
  queryCache: new QueryCache({}),
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        // Don't retry on 4xx client errors (except 401, 408)
        const status = error?.response?.status;
        if (status && status >= 400 && status < 500 && status !== 401 && status !== 408) {
          return false;
        }
        // Don't retry on 500+ server errors
        if (status && status >= 500) {
          return false;
        }
        // Retry once for network errors and other cases
        return failureCount < 1;
      },
      refetchOnWindowFocus: false,
    },
  },
});

function AppRoutes() {
  const element = useRoutes(routes);
  return element;
}

function GlobalComponents() {
  return (
    <>
      <PostModal />
      <ErrorModal />
    </>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Notification />
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <AppRoutes />
        <GlobalComponents />
      </Router>
    </QueryClientProvider>
  );
}

export default App;
